import React from "react";

// components
import MomtheraCommonTable from "../../table/MomtheraCommonTable";
import CommonPagination from "../../../pagination/CommonPagination";

function SearchTablePageLayout({
	type,
	pageInfo,

	tableBody,

	tablePageCnt,
	selectedPage,
	setSelectedPage,
	getNewTableDataByPagination,

	setShowRegisterModal,
	setShowDeleteModal,

	checkedItems,
	setCheckedItems,
	totalCheck,
	setTotalCheck,

	searchOption,
	setSearchOption,
	resetSearchOption,
	applySearchOption,

	selectedOrder,
	setSelectedOrder,

	selectedSort,
	setSelectedSort,

	clickEvent
}) {

	function handleInputSearchOption(key, value) {
		const arr = searchOption[key].split("|").filter(e=>e);
		if(arr.includes(value)){
			setSearchOption({
				...searchOption,
				[key]: arr.filter(e=>e!==value).join("|")
			})
		}else{
			arr.push(value);
			setSearchOption({
				...searchOption,
				[key]: arr.join("|")
			})
		}
	}

    return (
        <div className="dashboardContent">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">{pageInfo.title}</span>
			</div>
			<div className="dashboardContent__inner">
				<div className="patientManageList">
                    <div className="patientManageList__search">
                        <div className="SearchTablePage-Header">
                            <div className="Header-Title">검색 조건</div>
                            <div className="Header-Button">
                                <button className="White" onClick={resetSearchOption}>초기화</button>
                                <button className="Blue" onClick={applySearchOption}>검색</button>
                            </div>
                        </div>
						<div className="SearchWrapper">
							<div className="SearchBar">
								<span className="searchBar__label">검색</span>
								<input
									className="Search-Input"
									type="text"
									maxLength={300}
									placeholder={pageInfo.search.inputPlaceholder}
									onChange={(e)=>setSearchOption({
										...searchOption,
										search: e.target.value
									})}
									value={searchOption.search}
								/>
							</div>
							{/* 환자 관리 페이지 검색 조건 */}
							<div />
							<div className="SearchBar">
								<span className="searchBar__label">구분</span>
								<div className="Radio-Row">
									<div className="Radio-Row-Item">
										<input
											id="patientType-EC"
											name="patientType"
											type="checkbox"
											onChange={()=>handleInputSearchOption('patientType', 'EC')}
											checked={searchOption.patientType.includes('EC')}
										/>
										<label htmlFor="patientType-EC">탐색임상</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="patientType-CC"
											name="patientType"
											type="checkbox"
											onChange={()=>handleInputSearchOption('patientType', 'CC')}
											checked={searchOption.patientType.includes('CC')}
										/>
										<label htmlFor="patientType-CC">확증임상</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="patientType-PR"
											name="patientType"
											type="checkbox"
											onChange={()=>handleInputSearchOption('patientType', 'PR')}
											checked={searchOption.patientType.includes('PR')}
										/>
										<label htmlFor="patientType-PR">처방</label>
									</div>
								</div>
							</div>
							<div />
							<div className="SearchBar">
								<span className="searchBar__label">환자군</span>
								<div className="Radio-Row">
									<div className="Radio-Row-Item">
										<input
											id="patient-group-experimental"
											name="patient-group"
											type="checkbox"
											onChange={()=>handleInputSearchOption('patientGroup', 'EXP')}
											checked={searchOption.patientGroup.includes('EXP')}
										/>
										<label htmlFor="patient-group-experimental">실험군</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="patient-group-control"
											name="patient-group"
											type="checkbox"
											onChange={()=>handleInputSearchOption('patientGroup', 'COMP')}
											checked={searchOption.patientGroup.includes('COMP')}
										/>
										<label htmlFor="patient-group-control">대조군</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="patient-group-test"
											name="patient-group"
											type="checkbox"
											onChange={()=>handleInputSearchOption('patientGroup', 'TESTER')}
											checked={searchOption.patientGroup.includes('TESTER')}
										/>
										<label htmlFor="patient-group-test">테스터</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="patient-group-general"
											name="patient-group"
											type="checkbox"
											onChange={()=>handleInputSearchOption('patientGroup', 'COMMON')}
											checked={searchOption.patientGroup.includes('COMMON')}
										/>
										<label htmlFor="patient-group-general">일반</label>
									</div>
								</div>
							</div>
							<div />
							<div className="SearchBar">
								<span className="searchBar__label">교육</span>
								<div className="Radio-Row">										
									<div className="Radio-Row-Item">
										<input
											id="progress-10"
											name="progress"
											type="checkbox"
											onChange={()=>handleInputSearchOption('training', '10')}
											checked={searchOption.training.includes('10')}
										/>
										<label htmlFor="progress-10">시작 전</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="progress-20"
											name="progress"
											type="checkbox"
											onChange={()=>handleInputSearchOption('training', '20')}
											checked={searchOption.training.includes('20')}
										/>
										<label htmlFor="progress-20">정상</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="progress-30"
											name="progress"
											type="checkbox"
											onChange={()=>handleInputSearchOption('training', '30')}
											checked={searchOption.training.includes('30')}
										/>
										<label htmlFor="progress-30">종료</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="progress-40"
											name="progress"
											type="checkbox"
											onChange={()=>handleInputSearchOption('training', '40')}
											checked={searchOption.training.includes('40')}
										/>
										<label htmlFor="progress-40">미달</label>
									</div>
									<div className="Radio-Row-Item">
										<input
											id="progress-45"
											name="progress"
											type="checkbox"
											onChange={()=>handleInputSearchOption('training', '45')}
											checked={searchOption.training.includes('45')}
										/>
										<label htmlFor="progress-45">탈락</label>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="patientManageList__list">
						<div className="SearchTablePage-Header">
                            <div className="Header-Title">{pageInfo.list.title}</div>
							<div className="Header-Button">
								<button
									className="Blue"
									onClick={()=>setShowRegisterModal(true)}
								>
									환자 추가
								</button>
								<button
									className="Blue"
									onClick={() => {
										if(Object.values(checkedItems).length > 0){
											setShowDeleteModal(true);
										}else{											
											alert('환자를 선택해주세요.');
										}
									}}
								>
									환자 삭제
								</button>							
							</div>
						</div>
                        <div className="SearchTablePage-Table-Wrapper">
                            <MomtheraCommonTable
								type={type}
                                tableHeader={pageInfo.list.tableHeader}
                                tableBody={tableBody}
								checkedItems={checkedItems}
								setCheckedItems={setCheckedItems}
								totalCheck={totalCheck}
								setTotalCheck={setTotalCheck}
								clickEvent={clickEvent}
								selectedOrder={selectedOrder}
								setSelectedOrder={setSelectedOrder}
								selectedSort={selectedSort}
								setSelectedSort={setSelectedSort}
                            />
							<CommonPagination
								pageCnt={tablePageCnt}
								selectedPage={selectedPage}
								SetSelectedPage={setSelectedPage}
								GetNewTableData={getNewTableDataByPagination}
							/>
                        </div>
					</div>
				</div>
			</div>
		</div>
    );
}

export default SearchTablePageLayout;